"use client";

import { ClaimButtonProps } from "../types";
import { ClaimButtonTMA } from "./ClaimButton.tma";
import { ClaimButtonWeb } from "./ClaimButton.web";
import { ConditionalRender } from "@/components/shared/ConditionalRender";

export const ClaimButton = (props: ClaimButtonProps) => {
  return (
    <ConditionalRender tmaComponent={<ClaimButtonTMA {...props} />} webComponent={<ClaimButtonWeb {...props} />} />
  );
};
